var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-default__sidebar__logo-area"},[(_vm.width > 0)?_c('img',{attrs:{"width":_vm.width,"src":require('@/assets/images/Logo.png'),"alt":""}}):_c('img',{staticClass:"l-default__sidebar__logo-area__image",attrs:{"src":require('@/assets/images/Logo.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }